import type { ChipTone } from "@outpave/ds";
import RelationshipType from "enums/RelationshipType";

/**
 * The one place a relationship becomes a label and a tone.
 *
 * Three earlier surfaces each grew their own copy of this pairing and drifted
 * (see the resolveComplianceBadge, cardStatusTone and RenderUserStatus notes in
 * DS_MIGRATION.md), so the list table, the contact header and the people rows
 * all read this instead of humanizing the enum in JS.
 */
const RELATIONSHIP_LABEL_KEY: Record<RelationshipType, string> = {
  [RelationshipType.Customer]: "Customer",
  [RelationshipType.Contractor]: "Contractor",
  [RelationshipType.Supplier]: "Supplier",
  [RelationshipType.Other]: "Other",
};

const RELATIONSHIP_TONE: Record<RelationshipType, ChipTone> = {
  [RelationshipType.Customer]: "info",
  [RelationshipType.Contractor]: "positive",
  [RelationshipType.Supplier]: "warning",
  [RelationshipType.Other]: "neutral",
};

/** A translation KEY, so the caller owns the `t()` and no stored value reaches one. */
export const relationshipLabelKey = (
  relationship: RelationshipType | null | undefined,
): string | undefined =>
  relationship ? RELATIONSHIP_LABEL_KEY[relationship] : undefined;

export const relationshipTone = (
  relationship: RelationshipType | null | undefined,
): ChipTone => (relationship ? RELATIONSHIP_TONE[relationship] : "neutral");
